"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useLazyLoading", {
  enumerable: true,
  get: function get() {
    return _useLazyLoading["default"];
  }
});
var _useLazyLoading = _interopRequireDefault(require("./useLazyLoading"));